(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offigo-add-to-cart"] && !Shopify.designMode) return;
  try {
    
class StickyProductCart extends HTMLElement {
  #observer;
  #form;
  #primaryButton;
  #drawerTimeout;

  connectedCallback() {
    const productId = this.dataset.productId;
    this.#form = document.querySelector(`main product-form-component[data-product-id="${productId}"]`);
    this.#primaryButton = this.#form?.querySelector('[ref="addToCartButton"]');

    if (!this.#form || !this.#primaryButton) {
      this.remove();
      return;
    }

    this.#syncButtonState();
    this.#syncAccessories();

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        this.dataset.visible = String(!entry.isIntersecting);
      },
      { threshold: 0 }
    );
    this.#observer.observe(this.#primaryButton);

    this.querySelector('[ref="addButton"]')?.addEventListener('click', this.#submit);
    this.#form.addEventListener('change', this.#syncAccessories);
    document.addEventListener('variant:update', this.#syncVariant);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.querySelector('[ref="addButton"]')?.removeEventListener('click', this.#submit);
    this.#form?.removeEventListener('change', this.#syncAccessories);
    document.removeEventListener('variant:update', this.#syncVariant);
    document.removeEventListener('cart:update', this.#openCartDrawer);
    clearTimeout(this.#drawerTimeout);
  }

  #syncButtonState = () => {
    const addButton = this.querySelector('[ref="addButton"]');
    if (addButton instanceof HTMLButtonElement) addButton.disabled = this.#primaryButton?.disabled ?? true;
  };

  #syncVariant = (event) => {
    if (event.detail?.data?.productId !== this.dataset.productId) return;

    const variant = event.detail.resource;
    const price = event.detail?.data?.html?.querySelector('product-price [ref="priceContainer"]')?.textContent?.trim();
    const label = this.querySelector('[ref="variantLabel"]');
    const priceElement = this.querySelector('[ref="variantPrice"]');

    if (variant && this.dataset.hasOnlyDefaultVariant !== 'true' && label) label.textContent = variant.title;
    if (price && priceElement) priceElement.textContent = price;
    this.#syncButtonState();
  };

  #syncAccessories = () => {
    const container = this.querySelector('[ref="accessoryLines"]');
    if (!(container instanceof HTMLElement) || !this.#form) return;

    const accessories = Array.from(this.#form.querySelectorAll('[data-sticky-cart-accessory]')).filter((control) => {
      if (control instanceof HTMLInputElement) return control.checked;
      return control instanceof HTMLSelectElement && control.value !== '';
    });

    container.replaceChildren();
    accessories.forEach((control) => {
      const line = document.createElement('div');
      const label = document.createElement('span');
      const price = document.createElement('span');
      line.className = 'sticky-product-cart__accessory-line';
      label.textContent = control.dataset.stickyCartAccessoryLabel || control.getAttribute('aria-label') || control.name;
      price.textContent = control.dataset.stickyCartAccessoryPrice || '';
      line.append(label, price);
      container.append(line);
    });
    container.hidden = accessories.length === 0;
  };

  #submit = () => {
    if (this.#primaryButton?.disabled) return;

    document.addEventListener('cart:update', this.#openCartDrawer);
    clearTimeout(this.#drawerTimeout);
    this.#drawerTimeout = window.setTimeout(() => {
      document.removeEventListener('cart:update', this.#openCartDrawer);
    }, 8000);
    this.#primaryButton.click();
  };

  #openCartDrawer = (event) => {
    if (event.detail?.data?.source !== 'product-form-component' || event.detail?.data?.didError) return;

    document.querySelector('cart-drawer-component')?.open();
    document.removeEventListener('cart:update', this.#openCartDrawer);
    clearTimeout(this.#drawerTimeout);
  };
}

if (!customElements.get('sticky-product-cart')) {
  customElements.define('sticky-product-cart', StickyProductCart);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offigo-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('offigo-tabbed-products')) {
    customElements.define('offigo-tabbed-products', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.links = [...this.querySelectorAll('[data-offigo-tab-link]')];
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      activate = (index, focus = false) => {
        if (!this.tabs[index]) return;
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[i].hidden = !active;
        });
        this.links.forEach((link) => {
          link.hidden = Number(link.dataset.offigoTabLink) !== index;
        });
        if (focus) this.tabs[index].focus();
      };

      onClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        const index = this.tabs.indexOf(tab);
        if (index >= 0) this.activate(index);
      };

      onKeydown = (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(next, true);
      };

      onBlockSelect = (event) => {
        const tab = event.target.closest('[role="tab"]');
        const index = this.tabs.indexOf(tab);
        if (index >= 0) this.activate(index);
      };
    });
  }

  } catch(e) { console.error(e); }
})();
})();
